module.exports = __webpack_public_path__ + "img/404page2.4fad6c14.png";